// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured-page .table-card table th,
.featured-page .table-card table td {
  text-align: start;
}
.featured-page .table-card table th .sort-button {
  justify-content: flex-start;
}

::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item .action-icon {
  flex: 0 0 auto;
}

::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item .mdc-list-item__primary-text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.action-icon {
  margin-right: 10px;
  position: relative;
  top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/featured-product-management/featured-product-management.component.overrides.scss"],"names":[],"mappings":"AAEE;;EAEE,iBAAA;AADJ;AAIE;EACE,2BAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AAHF","sourcesContent":[".featured-page {\n\n  .table-card table th,\n  .table-card table td {\n    text-align: start;\n  }\n\n  .table-card table th .sort-button {\n    justify-content: flex-start;\n  }\n}\n\n::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item .action-icon {\n  flex: 0 0 auto;\n}\n\n::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-item .mdc-list-item__primary-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.action-icon {\n  margin-right: 10px;\n  position: relative;\n  top: 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
